import { CSSProperties } from '@material-ui/styles';
import { autorun, computed, IReactionDisposer, IReactionOptions, reaction } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { ISubmenuArray } from '../comps/Submenu';
import { useSubmenu } from '../mainpanel/useSubmenu';
import { mg } from '../mg/mg';
import { getOmnistore } from '../stores/Omnistore';

function FunctionalHelper(props: any) {
	const {submenu} = props;
	useSubmenu(submenu.filter(mg.isPresent));
	return null;
}

//TODO remove props type parameter
@observer export class OcScreen<P> extends React.Component<P> {
	// "abstract" //TODO use abstract
	name() {
		return '';
	}

	// "abstract"
	submenu() : ISubmenuArray {
		return [];
	}

	allowScroll() : boolean {
		return false;
	}

	/**
	 * Return a list of stores or their ids used by this screen.
	 * The empty string may be used as an ignorable entry.
	 */
	// "abstract"
	usedStores = () : Array<string | {id: string}> => []

	// "abstract"
	renderBody() : JSX.Element | null {
		return null;
	}

	_disposables: Array<IReactionDisposer> = []

	autoruns() : Array<() => void> {
		return [];
	}

	reactions() : Array<{when: () => any, then: () => void, opts?: IReactionOptions}> {
		return [];
	}

	componentDidMount() {
		this.autoruns().forEach(fn => this._disposables.push(autorun(fn)));
		this.reactions().forEach(r => this._disposables.push(reaction(r.when, r.then, r.opts)));
		getOmnistore().entityManagerStore.subscribe(this.name(), this.usedStores);
	}

	componentWillUnmount() {
		getOmnistore().entityManagerStore.unsubscribe(this.name());
		this._disposables.forEach(d => d());
	}

	@computed get _style() : CSSProperties {
		return {overflowX: 'hidden', overflowY: this.allowScroll() ? 'auto' : 'hidden', height: '100%'};
	}

	render() {
		const submenu = this.submenu().filter(mg.isPresent);
		return <>
			<FunctionalHelper submenu={submenu}/>
			<div style={this._style}>{this.renderBody()}</div>
		</>;
	}
}
